export default __webpack_public_path__ + "static/media/progress.f0d65f65.svg";